import React from "react";
import noPhotoImg from "../assets/img/no-photo.png";
import onlyInAppImg from "../assets/img/only-in-app.svg";
import {FormattedMessage, FormattedNumber, IntlProvider} from 'react-intl';
import * as StorageService from "../services/StorageService.js";
import {LOCALSTORAGE_ITEMS, USER_TYPES} from "../util/Constants";
import {EventBus} from "../util/EventBus";
import {getProdDesc, getProdName, roundHalfEven} from "../util/common";
import {PATH} from "../routes/routes.js";
import {useLocation, useNavigate} from "react-router";

function ProductCard(props) {

    const navigateTo = useNavigate();
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const userType = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TYPE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TYPE) : null;
    const hasMultiOrders = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).merchantConfig.multiOrders : null;
    const orderId = StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID) || null;
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const readonly = query.get('readonly');
    // const increaseQuantity = (e) => {
    //     if (props.isTakeAwayMenu && orderId) {
    //         EventBus.dispatch("closeOrderFirst");
    //         return;
    //     }
    //     e.stopPropagation();
    //
    //     if (StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE) ==null && props.isTakeAwayMenu!== true) {
    //         EventBus.dispatch("QRwasNotScaned");
    //         return;
    //     }
    //     if (!isShopOpen()) {
    //         EventBus.dispatch("shopIsClosed");
    //         return;
    //     }
    //
    //     if (!hasMultiOrders && StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID)) {
    //         EventBus.dispatch("multiOrdersSetToFalse");
    //         return;
    //     }
    //     if (props.hasOptions) {
    //         toEditProductPage(props.product.pid)
    //     }else{
    //         props.increaseQuantity(props.product);
    //     }
    // }
    //
    //
    // const decreaseQuantity = (e) => {
    //     e.stopPropagation();
    //         props.decreaseQuantity(props.product);
    // }

    const toEditProductPage = (pid) => {
        if (props.product.onlyLoggedUser && (userType === USER_TYPES.ANONYMOUS || userType === null)) {
            EventBus.dispatch("accessingOnlyLoggedUsersProduct");
            return;
        }

        const productDetails = {
            product: props.product,
            category: props.category,
            quantity: props.quantity,
            onlyLoggedUser: props.product.onlyLoggedUser,
            isTakeAwayMenu: props.isTakeAwayMenu || false
        }
        StorageService.setItem(LOCALSTORAGE_ITEMS.SCROLL_POSITION, window.pageYOffset);
        StorageService.setItem(LOCALSTORAGE_ITEMS.PRODUCT_DETAILS, JSON.stringify(productDetails));
        //TODO useNavigate with search params
        navigateTo({
            pathname: PATH.PRODUCT_DETAILS + "/" + pid,
            search: readonly ? "readonly=true" : "readonly=false",
        });

    }

    return (


        <div data-qa="product-card" className="product-card">
            <div data-qa="product-card-go-to-product-btn" className="row"
                 onClick={() => toEditProductPage(props.product.pid)}>
                <div className="product-img">
                    <img className="productImg"
                         src={props.product.pic || noPhotoImg}
                         onError={({currentTarget}) => {
                             currentTarget.onerror = null; // prevents looping
                             currentTarget.src = noPhotoImg;
                         }}/>

                    {/*if product is discounted and requires app login*/}
                    {props.product.discount && props.product.onlyLoggedUser && (userType === USER_TYPES.ANONYMOUS || userType === null) ?
                        <div className="only-in-app">
                            <img alt="only in app" src={onlyInAppImg}/>
                            <FormattedMessage id="LoginToAdd"/>
                        </div> : null
                    }

                    {/*if product is for logged in only*/}
                    {props.product.onlyLoggedUser && (userType === USER_TYPES.ANONYMOUS || userType === null) ?
                        <div className="only-in-app">
                            <img alt="only in app" src={onlyInAppImg}/>
                            <FormattedMessage id="LoginToAdd"/>
                        </div> : null}

                    {/*if product has discount but doesn't require app loginy*/}
                    {props.product.discount && !props.product.onlyLoggedUser ?
                        <div className="discount">
                            {/*<img alt="discount" src={discountImg}/>*/}
                            <span>-{props.product.discount}%</span>
                        </div> : null}

                </div>
                <div className="product-info">
                    <div className="product-name" data-qa="product-name" data-qa-only-in-app={props.product.onlyLoggedUser}>{getProdName(props.product)}</div>

                    {props.product.desc === null ? null :
                        <div className="product-description"><p>{getProdDesc(props.product)}</p></div>}

                    <div className="row">
                        <div className="product-price">
                            {props.product.discount ?
                                <div className="discounted-price-container">
                                    <p className="price-without-discount">
                                        <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                            <FormattedNumber
                                                value={props.product.finalPriceWithReqExtras / 100.0}
                                                style="currency"
                                                minimumFractionDigits={2}
                                                maximumFractionDigits={2}
                                                currency={shopDetails.currency}/>
                                        </IntlProvider>
                                    </p>
                                    <p className="price-with-discount">
                                        <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                            <FormattedNumber
                                                value={roundHalfEven(props.product.price * (100 - props.product.discount) / 100) / 100.0 + props.product.reqExtrasPrice / 100.0}
                                                style="currency"
                                                minimumFractionDigits={2}
                                                maximumFractionDigits={2}
                                                currency={shopDetails.currency}


                                            />
                                        </IntlProvider>
                                    </p>
                                </div>

                                : <p className="price-without-discount">
                                    <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                        <FormattedNumber
                                            value={props.product.finalPriceWithReqExtras / 100.0}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={shopDetails.currency}/>
                                    </IntlProvider>
                                </p>
                            }
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );

}


export default ProductCard;
